import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useAppContext } from "../../layout/layout";

import Wrapper from "./following-cursor-component.styles";
const FollowingCursor = () => {
  const { isHover } = useAppContext();

  const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 });
  const [cursorSlowPos, setCursorSlowPos] = useState({ x: 0, y: 0 });

  const updateCursorPosition = (e) => {
    const { clientX: x, clientY: y } = e;
    setCursorPos({ x, y });
  };

  useEffect(() => {
    const moveCursorSlowly = () => {
      setCursorSlowPos((prevPos) => ({
        x: prevPos.x + (cursorPos.x - prevPos.x) * 0.2, // Adjust the multiplier to control the speed
        y: prevPos.y + (cursorPos.y - prevPos.y) * 0.2,
      }));
    };

    window.addEventListener("mousemove", updateCursorPosition);
    const intervalId = setInterval(moveCursorSlowly, 0);

    return () => {
      window.removeEventListener("mousemove", updateCursorPosition);
      clearInterval(intervalId);
    };
  }, [cursorPos]);
  return (
    <Wrapper>
      <motion.div
        style={{
          left: cursorSlowPos.x - 20,
          top: cursorSlowPos.y - 20,
          opacity: 0.2,
          scale: isHover ? 2 : 1,
        }}
        transition={{ ease: "linear", duration: 0.2 }}
      />
    </Wrapper>
  );
};
export default FollowingCursor;
